import { render, staticRenderFns } from "./Enclosure.vue?vue&type=template&id=68a5e210&scoped=true&lang=true"
import script from "./Enclosure.vue?vue&type=script&lang=js"
export * from "./Enclosure.vue?vue&type=script&lang=js"
import style0 from "./Enclosure.vue?vue&type=style&index=0&id=68a5e210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a5e210",
  null
  
)

export default component.exports